var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26151 28.1874C5.93188 28.1046 5.62868 27.9248 5.35191 27.648C5.07517 27.3713 4.89537 27.0681 4.8125 26.7384L26.7384 4.8125C27.0963 4.90946 27.403 5.08927 27.6586 5.35191C27.9142 5.61458 28.0975 5.91778 28.2086 6.26151L6.26151 28.1874ZM4.8125 19.4059V16.5079L16.5079 4.8125H19.4059L4.8125 19.4059ZM4.8125 9.17541V7.29809C4.8125 6.60353 5.05312 6.01563 5.53437 5.53438C6.01562 5.05313 6.60353 4.8125 7.29809 4.8125H9.17541L4.8125 9.17541ZM23.8245 28.1874L28.1874 23.8245V25.7018C28.1874 26.3964 27.9468 26.9843 27.4656 27.4656C26.9843 27.9468 26.3964 28.1874 25.7018 28.1874H23.8245ZM13.594 28.1874L28.1874 13.594V16.492L16.492 28.1874H13.594Z",
    fill: "#505558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.4dc40c2f1590f67415fe40dff7305c4e.svg";
export { ForwardRef as ReactComponent };